"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var extendHOC_1 = __importDefault(require("./extendHOC"));
function withDeferRender(WrappedComponent) {
    var DefferRenderWrapper = /** @class */ (function (_super) {
        __extends(DefferRenderWrapper, _super);
        function DefferRenderWrapper() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                shouldRender: typeof window === 'undefined',
            };
            return _this;
        }
        DefferRenderWrapper.prototype.componentDidMount = function () {
            var _this = this;
            this.requestId = window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                    return _this.setState({ shouldRender: true });
                });
            });
        };
        DefferRenderWrapper.prototype.componentWillUnmount = function () {
            window.cancelAnimationFrame(this.requestId);
        };
        DefferRenderWrapper.prototype.render = function () {
            var shouldRender = this.state.shouldRender;
            return shouldRender ? react_1.default.createElement(WrappedComponent, __assign({}, this.props)) : null;
        };
        return DefferRenderWrapper;
    }(react_1.default.Component));
    return extendHOC_1.default(WrappedComponent, DefferRenderWrapper);
}
exports.default = withDeferRender;
//# sourceMappingURL=withDeferRender.js.map